import { styled } from 'dripsy';
import React, { ReactNode } from 'react';
import { View, ViewProps } from 'react-native';

const Container = styled(View)({
  flexDirection: ['column', 'row'],
  alignItems: 'center',
  width: ['100%', 165],
});

const Space = styled(View)({
  padding: '$3',
});

export interface IButtonsLayoutProps extends ViewProps {
  children: ReactNode[];
}

export function ButtonsLayout({
  children,
  ...props
}: IButtonsLayoutProps) {
  return (
    <Container {...props}>
      {children[0]}
      <Space />
      {children[1]}
    </Container>
  );
}
